import script from "./HeaderItemButton.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderItemButton.vue?vue&type=script&setup=true&lang=js"

import "./HeaderItemButton.vue?vue&type=style&index=0&id=6e88d8a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e88d8a7"]])

export default __exports__